import { render, staticRenderFns } from "./staticBanner.vue?vue&type=template&id=668b64ec&scoped=true&"
import script from "./staticBanner.vue?vue&type=script&lang=js&"
export * from "./staticBanner.vue?vue&type=script&lang=js&"
import style0 from "./staticBanner.vue?vue&type=style&index=0&id=668b64ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b64ec",
  null
  
)

export default component.exports